import './CreateChapter.sass';

import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap-button-loader';

import {
  CHAPTER_AUDIO_PLAYLIST_GENERATION_ERROR,
  CHAPTER_AUDIO_PLAYLIST_GENERATION_LOADING,
  CHAPTER_AUDIO_PLAYLIST_GENERATION_PENDING,
  CHAPTER_AUDIO_PLAYLIST_GENERATION_SUCCESS,
} from '../../../components/Books/constants';
import {
  dateOptions,
  localeDateName,
  timeOptions,
} from '../../../constants/date';
import AudioVoiceSelector from '../../AudioVoiceSelector/AudioVoiceSelector';
import DropFileInput from '../../DropFileInput/DropFileInput';
import { SimpleInput, SimpleTextarea } from '../../Input/Input';
import Spinner from '../../Spinner/Spinner';

class CreateChapter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: null,
      waiting: false,
      reference:
        this.props.chapter.reference ?? this.props.references?.[0].id ?? null,
      enabled: this.props.chapter.enabled,
      description: this.props.chapter.description,
      presentationIndex: this.props.chapter.presentationIndex,
      name: this.props.chapter.name,
      noPagesNumbers: this.props.chapter.noPagesNumbers,
      pdf: this.props.chapter.pdfUrl,
      audioSummary: this.props.chapter.audioSummary?.audioUrl,
      audioSummaryGenerationState:
        this.props.chapter.audioSummary?.generationState,
      weNeedThisPublication: this.props.chapter.weNeedThisPublication ?? false,
      isRestricted: this.props.chapter.isRestricted ?? false,
      playlist: this.props.edit
        ? {
            ...this.props.chapter.playlist,
            chapter: this.props.chapter.id,
            voiceSelected: null,
            new: false, // this mark is for generate or re-generate audio
            upgrade: false, // this mark is for generate audios only for update or new questions
            delete: false, // this mark is for remove all audios including playlist
          }
        : null,
    };
  }

  UNSAFE_componentWillReceiveProps({ submitSucceeded }) {
    if (submitSucceeded && this.state.waiting) {
      this.setState({ waiting: false });
    }
  }

  validate(chaptersOfReference = 0, edit = false) {
    const errors = {};
    const fields = { ...this.state };

    if (!fields.name || fields.name === '') {
      errors.name = 'Title field is required';
    }

    if (!fields.description) {
      errors.description = 'Description field is required';
    }

    if (fields.pdf?.name && !fields.pdf.name.toLowerCase().endsWith('.pdf')) {
      errors.pdf = 'Please select a pdf file';
    }

    if (
      fields.audioSummary?.name &&
      !fields.audioSummary.name.toLowerCase().endsWith('.mp3')
    ) {
      errors.audioSummary = 'Please select an MP3 audio file';
    }

    if (!fields.noPagesNumbers) {
      fields.noPagesNumbers = false;
    }

    if (!edit && !fields.reference) {
      errors.reference = 'Must select a reference';
    }

    if (edit && !fields.presentationIndex) {
      errors.presentationIndex = 'Presentation index is required';
    }

    if (
      edit &&
      (fields.presentationIndex < 0 ||
        fields.presentationIndex > chaptersOfReference)
    ) {
      errors.presentationIndex =
        'Invalid index: presentation index must be a value within the chapter list.';
    }

    if (fields.playlist?.audios) {
      // avoid send audio array to backend
      delete fields.playlist.audios;
    }

    if (fields.playlist?.new && !fields.playlist?.voiceSelected) {
      errors.voiceSelected = 'Please select a voice for audios';
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.setState({ errors: null, waiting: true }, () => {
      this.props.onSubmit(fields);
    });
  }

  handleKeyPress = (event) => {
    if (event.ctrlKey && event.key === 'Enter') {
      document.getElementById('btn-success').click();
    }
  };

  handleGenerateAudio = () => {
    const { playlist } = this.state;
    this.setState({
      playlist: {
        ...playlist,
        new: !playlist?.new,
        upgrade: false,
        voiceSelected: null,
        delete: false,
      },
    });
  };

  handleUpgradeAudio = () => {
    const { playlist } = this.state;
    this.setState({
      playlist: {
        ...playlist,
        upgrade: !playlist?.upgrade,
        new: false,
        voiceSelected: null,
        delete: false,
      },
    });
  };

  handleRemoveAudio = () => {
    const { playlist } = this.state;
    this.setState({
      playlist: {
        ...playlist,
        delete: !playlist.delete,
        upgrade: false,
        new: false,
        voiceSelected: null,
      },
    });
  };

  handleOnChangePlaylistEnabled = () => {
    const { playlist } = this.state;
    this.setState({
      playlist: {
        ...playlist,
        enabled: !playlist?.enabled,
        voiceSelected: null,
      },
    });
  };

  handleSelectVoice = (voice) => {
    const { playlist } = this.state;
    this.setState({
      playlist: {
        ...playlist,
        voiceSelected: voice,
      },
    });
  };

  getPlayListCreatedDate = () => {
    const date = new Date(
      this.props.chapter.playlist?.updatedAt || this.state.playlist?.updatedAt,
    );
    const formattedDate = date.toLocaleDateString(localeDateName, dateOptions);
    const formattedTime = date.toLocaleTimeString(localeDateName, timeOptions);

    const formattedDateTime = this.state.playlist?.updatedAt
      ? `${formattedDate} ${formattedTime}`
      : '-';
    return formattedDateTime;
  };

  render() {
    const {
      onSubmit,
      onCancel,
      onDelete,
      references,
      edit = false,
      chapter = {},
      addChapter = false,
      chaptersOfReference = 0,
    } = this.props;

    const reference = this.props.references?.[0]
      ? this.props.references[0]
      : this.props.edit && this.props.reference
        ? this.props.reference
        : null;

    let refOfChapter;
    if (edit && chapter.reference) {
      refOfChapter = reference;
    }

    const title = edit ? 'Edit Chapter' : 'Create Chapter';

    let refName = '';
    if (references?.length > 0) {
      refName = references[references.length - 1].name;
    }

    return (
      <div className="create-chapter-component">
        <div className="card-block">
          <div className="createChapterTitle">
            {title}
            <i
              className="fa fa-times fa-xs"
              onClick={() => this.props.onCancel()}
            />
            <hr style={{ width: '600px', marginLeft: '-15px' }} />
          </div>
          <form
            onKeyDown={this.handleKeyPress}
            className="widget-form new-admin-form"
            onSubmit={() => this.validate(chaptersOfReference, edit)}
          >
            <Row>
              <Col md={4}>
                {!edit && !addChapter && (
                  <span className="InputLebel">Reference</span>
                )}
              </Col>
              <Col md={8} className="mt-10">
                {!edit && !addChapter && (
                  <div className="form-group">
                    <div className="input-group mb-3">
                      <span className="InputLebel">{refName}</span>
                    </div>
                    {this.state.errors?.reference && (
                      <span className="errors">
                        {this.state.errors.reference}
                      </span>
                    )}
                  </div>
                )}
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                {edit && chapter.reference && (
                  <span className="InputLebel">Reference</span>
                )}
              </Col>
              <Col md={8} className="mt-10">
                {edit && chapter.reference && (
                  <div className="InputLebel" disabled>
                    {refOfChapter.name}
                  </div>
                )}
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <span className="InputLebel">Title</span>
              </Col>
              <Col md={8} className="mt-10">
                <SimpleInput
                  type="text"
                  value={this.state.name}
                  onChange={(e) => {
                    this.setState({ name: e.target.value });
                  }}
                  error={this.state.errors?.name ?? null}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <span className="InputLebel">Description</span>
              </Col>
              <Col md={8} className="mt-10">
                <SimpleTextarea
                  type="text"
                  value={this.state.description}
                  onChange={(e) => {
                    this.setState({ description: e.target.value });
                  }}
                  error={this.state.errors?.description ?? null}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <span className="InputLebel">Pages numbers</span>
              </Col>
              <Col md={8} className="mt-10">
                <SimpleInput
                  description="No pages numbers"
                  type="checkbox"
                  value={this.state.noPagesNumbers}
                  onChange={() => {
                    this.setState({
                      noPagesNumbers: !this.state.noPagesNumbers,
                    });
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <span className="InputLebel">Enabled</span>
              </Col>
              <Col md={8} className="mt-10">
                <SimpleInput
                  description="Enabled"
                  type="checkbox"
                  value={this.state.enabled}
                  onChange={() => {
                    this.setState({ enabled: !this.state.enabled });
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <span className="InputLebel">We need this publication!</span>
              </Col>
              <Col md={8} className="mt-10">
                <SimpleInput
                  type="checkbox"
                  value={this.state.weNeedThisPublication}
                  onChange={() => {
                    this.setState({
                      weNeedThisPublication: !this.state.weNeedThisPublication,
                    });
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <label className="InputLebel" htmlFor="isRestricted">
                  Is restricted
                </label>
              </Col>
              <Col md={8} className="mt-10">
                <SimpleInput
                  type="checkbox"
                  value={this.state.isRestricted}
                  onChange={() => {
                    this.setState({
                      isRestricted: !this.state.isRestricted,
                    });
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                {edit && <span className="InputLebel">Presentation index</span>}
              </Col>
              <Col md={8}>
                {edit && (
                  <SimpleInput
                    type="text"
                    value={this.state.presentationIndex}
                    onChange={(e) => {
                      this.setState({ presentationIndex: e.target.value });
                    }}
                    error={this.state.errors?.presentationIndex ?? null}
                  />
                )}
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <span className="InputLebel">Pdf</span>
              </Col>
              <Col md={6} className="mt-10">
                <DropFileInput
                  input={{
                    onChange: (e) => {
                      this.setState({ pdf: e });
                    },
                  }}
                  value={this.state.pdf}
                  defaultValue={this.state.pdf}
                  multiple={false}
                  accept="application/pdf"
                  getUrlPdf={this.props.getUrlPdf}
                />
              </Col>
              <Col md={2}>
                {this.state.errors?.pdf && (
                  <span className="errors">{this.state.errors.pdf}</span>
                )}
              </Col>
            </Row>
            <Row>
              {edit &&
                this.props.chapter.playlist?.generationState ===
                  CHAPTER_AUDIO_PLAYLIST_GENERATION_LOADING && (
                  <Spinner text="Generating or upgrading audio" />
                )}
              {edit &&
                this.props.chapter.playlist?.generationState ===
                  CHAPTER_AUDIO_PLAYLIST_GENERATION_SUCCESS && (
                  <>
                    <Col md={4}>
                      <span>Audio</span>
                    </Col>
                    <Col md={8}>
                      <Row className="playlistInfo">
                        <table border="1" cellPadding="8" cellSpacing="0">
                          <tbody>
                            <tr>
                              <td>Created or updated at</td>
                              <td>{this.getPlayListCreatedDate()}</td>
                            </tr>
                            <tr>
                              <td>Amount of questions</td>
                              <td>{this.state.playlist?.audiosCount ?? 0}</td>
                            </tr>
                            <tr>
                              <td>Generated with voice</td>
                              <td>
                                {this.state.playlist?.voice?.name ?? 'no-data'}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </Row>
                      <Row className="generateVoiceOptions">
                        <label>
                          <SimpleInput
                            type="checkbox"
                            checked={!this.state.playlist?.enabled}
                            onChange={this.handleOnChangePlaylistEnabled}
                          />
                          Disabled
                        </label>

                        {this.state.playlist?.enabled && (
                          <>
                            <label>
                              <SimpleInput
                                type="checkbox"
                                checked={this.state.playlist?.upgrade}
                                onChange={this.handleUpgradeAudio}
                              />
                              Upgrade
                            </label>

                            <label>
                              <SimpleInput
                                type="checkbox"
                                checked={this.state.playlist?.new}
                                onChange={this.handleGenerateAudio}
                              />
                              Re-generate
                            </label>

                            <label>
                              <SimpleInput
                                type="checkbox"
                                checked={this.state.playlist?.delete}
                                onChange={this.handleRemoveAudio}
                              />
                              Remove Playlist (all audios)
                            </label>

                            {this.state.playlist?.new && (
                              <AudioVoiceSelector
                                onSelectVoice={this.handleSelectVoice}
                              />
                            )}
                          </>
                        )}
                      </Row>
                    </Col>
                  </>
                )}
              {edit &&
                (!this.props.chapter.playlist ||
                  this.props.chapter.playlist?.generationState ===
                    CHAPTER_AUDIO_PLAYLIST_GENERATION_PENDING ||
                  this.props.chapter.playlist?.generationState ===
                    CHAPTER_AUDIO_PLAYLIST_GENERATION_ERROR) && (
                  <>
                    <Col md={4}>
                      <span>Generate Audio Playlist</span>
                    </Col>
                    <Col md={8} className="d-flex align-items-start">
                      <Row className="generateVoiceOptions">
                        <SimpleInput
                          type="checkbox"
                          checked={this.state.playlist?.new}
                          onChange={this.handleGenerateAudio}
                        />
                        {this.state.playlist?.new && (
                          <AudioVoiceSelector
                            onSelectVoice={this.handleSelectVoice}
                          />
                        )}
                      </Row>
                    </Col>
                  </>
                )}
            </Row>
            <Row>
              <Col md={4}>
                <span className="InputLebel">Audio Summary</span>
              </Col>
              <Col md={6} className="mt-10">
                {this.state.audioSummaryGenerationState ===
                CHAPTER_AUDIO_PLAYLIST_GENERATION_LOADING ? (
                  <Spinner text="Generating audio summary" />
                ) : (
                  <DropFileInput
                    input={{
                      onChange: (e) => {
                        this.setState({ audioSummary: e });
                      },
                    }}
                    value={this.state.audioSummary}
                    defaultValue={this.state.audioSummary}
                    multiple={false}
                    accept="audio/mp3,audio/mpeg"
                    getUrlPdf={this.props.getUrlPdf}
                  />
                )}
              </Col>
              <Col md={2}>
                {this.state.errors?.audioSummary && (
                  <span className="errors">
                    {this.state.errors.audioSummary}
                  </span>
                )}
              </Col>
            </Row>
          </form>
          {addChapter && reference.name && (
            <span className="InputLebel" disabled>
              {reference.name}
            </span>
          )}
          {this.state.errors && this.state.errors.general && (
            <div className="errors">{this.state.errors.general}</div>
          )}
          <hr style={{ width: '600px', marginLeft: '-15px' }} />
          <div className="bottom-buttons-new">
            {edit && (
              <i
                className="fa fa-trash icon-button"
                title="Remove this chapter."
                onClick={(ev) => {
                  ev.stopPropagation();
                  onDelete(reference.id, chapter.id, chapter.presentationIndex);
                }}
              />
            )}
            <Button
              id="btn-success"
              className="btn btn-success"
              onClick={() => this.validate(chaptersOfReference, edit, onSubmit)}
              loading={this.state.waiting}
            >
              Submit
            </Button>
            <Button className="btn btn-secondary" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

CreateChapter.defaultProps = {
  chapter: {
    reference: null,
    description: '',
    presentationIndex: '',
    name: '',
    noPagesNumbers: false,
    pdf: '',
    audioSummaryUrl: null,
    enabled: true,
    weNeedThisPublication: false,
    isRestricted: false,
  },
};

export default CreateChapter;
